import React from "react";

export default function Page({
  title,
  icon = null,
  padded = null,
  right = null,
  size = null,
  children,
  className = "",
}) {
  const isSimpleTitle = typeof title === "string" || typeof title === "number";

  const contInnerClass =
    size && size === "large"
      ? "w-full p-0 flex flex-col md:max-w-[1200px] md:p-5"
      : "w-full p-0 flex flex-col md:max-w-[978px] md:p-5";

  return (
    <div className="flex flex-col justify-center items-center">
      <div className={`${contInnerClass} ${className}`}>
        <div className="flex flex-col text-altgray-900 text-[130%] font-semibold py-5 px-2.5 md:py-5 md:px-1.5">
          <div
            className={`flex flex-row justify-between min-h-9 ${
              isSimpleTitle ? "items-center" : "items-start"
            }`}
          >
            <div className="flex items-center w-full">
              {icon && (
                <div className="text-orange-400 mr-3 text-[91%]">{icon}</div>
              )}
              {isSimpleTitle ? <h3>{title}</h3> : <div className="w-full">{title}</div>}
            </div>
            {right && <div className="flex">{right}</div>}
          </div>
        </div>
        <div
          className={`flex mb-20 flex-col bg-white border border-altgray-200 border-b-[3px] md:rounded-lg overflow-hidden 
        ${padded ? "p-10" : ""}`}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
